export const DEMO_USERS = [
    {
        id: 'user_current',
        name: 'You',
        dataCategories: ['health', 'fitness', 'shopping'],
        dataValue: 847,
        connectionStrength: 100,
        isAnonymous: false,
    },
    { id: 'user_1', name: 'Anonymous', dataCategories: ['health'], dataValue: 523, connectionStrength: 78, isAnonymous: true, targetCid: 1 },
    { id: 'user_2', name: 'Anonymous', dataCategories: ['health'], dataValue: 412, connectionStrength: 65, isAnonymous: true, targetCid: 1 },
    { id: 'user_3', name: 'Anonymous', dataCategories: ['health'], dataValue: 689, connectionStrength: 82, isAnonymous: true, targetCid: 1 },
    { id: 'user_4', name: 'Anonymous', dataCategories: ['health'], dataValue: 356, connectionStrength: 54, isAnonymous: true, targetCid: 1 },
    { id: 'user_5', name: 'Anonymous', dataCategories: ['shopping'], dataValue: 721, connectionStrength: 89, isAnonymous: true, targetCid: 2 },
    { id: 'user_6', name: 'Anonymous', dataCategories: ['shopping'], dataValue: 445, connectionStrength: 71, isAnonymous: true, targetCid: 2 },
    { id: 'user_7', name: 'Anonymous', dataCategories: ['shopping'], dataValue: 587, connectionStrength: 76, isAnonymous: true, targetCid: 2 },
    { id: 'user_8', name: 'Anonymous', dataCategories: ['fitness'], dataValue: 634, connectionStrength: 84, isAnonymous: true, targetCid: 3 },
    { id: 'user_9', name: 'Anonymous', dataCategories: ['fitness'], dataValue: 512, connectionStrength: 68, isAnonymous: true, targetCid: 3 },
    { id: 'user_10', name: 'Anonymous', dataCategories: ['fitness'], dataValue: 478, connectionStrength: 62, isAnonymous: true, targetCid: 3 },
    { id: 'user_11', name: 'Anonymous', dataCategories: ['social'], dataValue: 389, connectionStrength: 58, isAnonymous: true, targetCid: 4 },
    { id: 'user_12', name: 'Anonymous', dataCategories: ['social'], dataValue: 423, connectionStrength: 64, isAnonymous: true, targetCid: 4 },
    { id: 'user_13', name: 'Anonymous', dataCategories: ['location'], dataValue: 567, connectionStrength: 73, isAnonymous: true, targetCid: 5 },
    { id: 'user_14', name: 'Anonymous', dataCategories: ['location'], dataValue: 498, connectionStrength: 66, isAnonymous: true, targetCid: 5 },
    { id: 'user_15', name: 'Anonymous', dataCategories: ['health', 'fitness'], dataValue: 712, connectionStrength: 87, isAnonymous: true, targetCid: 1 },
    { id: 'user_16', name: 'Anonymous', dataCategories: ['shopping', 'social'], dataValue: 534, connectionStrength: 70, isAnonymous: true, targetCid: 2 },
    { id: 'user_17', name: 'Anonymous', dataCategories: ['fitness', 'location'], dataValue: 601, connectionStrength: 79, isAnonymous: true, targetCid: 3 },
    { id: 'user_18', name: 'Anonymous', dataCategories: ['health'], dataValue: 445, connectionStrength: 59, isAnonymous: true, targetCid: 1 },
    { id: 'user_19', name: 'Anonymous', dataCategories: ['shopping'], dataValue: 378, connectionStrength: 52, isAnonymous: true, targetCid: 2 },
    { id: 'user_20', name: 'Anonymous', dataCategories: ['fitness'], dataValue: 623, connectionStrength: 81, isAnonymous: true, targetCid: 3 },
    { id: 'corp_health', name: 'Health Research', dataCategories: ['health'], dataValue: 0, connectionStrength: 45, isAnonymous: false, targetCid: 1 },
    { id: 'corp_fitness', name: 'FitTech Analytics', dataCategories: ['fitness'], dataValue: 0, connectionStrength: 38, isAnonymous: false, targetCid: 3 },
    { id: 'corp_retail', name: 'Retail Insights', dataCategories: ['shopping'], dataValue: 0, connectionStrength: 42, isAnonymous: false, targetCid: 2 },
    { id: 'corp_social', name: 'Social Analytics', dataCategories: ['social'], dataValue: 0, connectionStrength: 35, isAnonymous: false, targetCid: 4 },
];
export const DEMO_CONNECTIONS = [];
export const DEMO_INSIGHTS = [
    {
        id: 'insight_1',
        type: 'health',
        title: 'Heart Rate Patterns',
        description: 'Your resting heart rate has improved by 8% over the last 30 days',
        value: 8,
        trend: 'up',
        aiGenerated: true,
        detail: {
            chartData: [
                { label: 'Week 1', value: 72 },
                { label: 'Week 2', value: 70 },
                { label: 'Week 3', value: 68 },
                { label: 'Week 4', value: 66 },
            ],
            comparison: {
                userValue: 66,
                averageValue: 72,
                percentile: 78,
            },
            recommendations: [
                'Continue your current exercise routine',
                'Consider adding meditation for further improvement',
                'Maintain consistent sleep schedule',
            ],
            additionalStats: [
                { label: 'Peak Heart Rate', value: '142 bpm' },
                { label: 'Recovery Time', value: '2.3 min' },
                { label: 'HRV Score', value: '58 ms' },
            ],
        },
    },
    {
        id: 'insight_2',
        type: 'fitness',
        title: 'Activity Level',
        description: 'You are in the top 15% of users with similar profiles',
        value: 15,
        trend: 'up',
        aiGenerated: true,
        detail: {
            chartData: [
                { label: 'Mon', value: 8500 },
                { label: 'Tue', value: 12000 },
                { label: 'Wed', value: 9200 },
                { label: 'Thu', value: 11500 },
                { label: 'Fri', value: 7800 },
                { label: 'Sat', value: 15000 },
                { label: 'Sun', value: 6500 },
            ],
            comparison: {
                userValue: 10071,
                averageValue: 7500,
                percentile: 85,
            },
            recommendations: [
                'Great job! You exceed daily step goals regularly',
                'Try to maintain activity on rest days',
                'Consider high-intensity interval training',
            ],
            additionalStats: [
                { label: 'Daily Average', value: '10,071 steps' },
                { label: 'Active Minutes', value: '67 min/day' },
                { label: 'Calories Burned', value: '2,340 kcal' },
            ],
        },
    },
    {
        id: 'insight_3',
        type: 'shopping',
        title: 'Purchase Patterns',
        description: 'Your sustainable product preference is 34% higher than average',
        value: 34,
        trend: 'stable',
        aiGenerated: true,
        detail: {
            chartData: [
                { label: 'Jan', value: 28 },
                { label: 'Feb', value: 32 },
                { label: 'Mar', value: 35 },
                { label: 'Apr', value: 34 },
            ],
            comparison: {
                userValue: 34,
                averageValue: 25,
                percentile: 72,
            },
            recommendations: [
                'Your eco-conscious choices make a difference',
                'Explore local farmers markets for fresh produce',
                'Consider carbon-neutral shipping options',
            ],
            additionalStats: [
                { label: 'Eco Products', value: '34%' },
                { label: 'Local Purchases', value: '22%' },
                { label: 'CO2 Saved', value: '12.4 kg' },
            ],
        },
    },
    {
        id: 'insight_4',
        type: 'health',
        title: 'Sleep Quality',
        description: 'Average sleep duration: 7.2 hours (recommended: 7-9 hours)',
        value: 7.2,
        trend: 'stable',
        aiGenerated: true,
        detail: {
            chartData: [
                { label: 'Mon', value: 7.5 },
                { label: 'Tue', value: 6.8 },
                { label: 'Wed', value: 7.2 },
                { label: 'Thu', value: 7.4 },
                { label: 'Fri', value: 6.5 },
                { label: 'Sat', value: 8.2 },
                { label: 'Sun', value: 7.8 },
            ],
            comparison: {
                userValue: 7.2,
                averageValue: 6.8,
                percentile: 65,
            },
            recommendations: [
                'Maintain consistent bedtime routine',
                'Reduce screen time 1 hour before sleep',
                'Keep bedroom temperature between 18-20°C',
            ],
            additionalStats: [
                { label: 'Deep Sleep', value: '1.8 hours' },
                { label: 'REM Sleep', value: '1.5 hours' },
                { label: 'Sleep Score', value: '82/100' },
            ],
        },
    },
    {
        id: 'insight_5',
        type: 'social',
        title: 'Network Connections',
        description: '24 potential data matches found in your network',
        value: 24,
        trend: 'up',
        aiGenerated: true,
        detail: {
            chartData: [
                { label: 'Week 1', value: 18 },
                { label: 'Week 2', value: 20 },
                { label: 'Week 3', value: 22 },
                { label: 'Week 4', value: 24 },
            ],
            comparison: {
                userValue: 24,
                averageValue: 15,
                percentile: 88,
            },
            recommendations: [
                'Review pending connection requests',
                'Engage with matched users for data sharing',
                'Explore corporate partnership opportunities',
            ],
            additionalStats: [
                { label: 'Active Matches', value: '24' },
                { label: 'Pending Requests', value: '8' },
                { label: 'Data Shared', value: '156 MB' },
            ],
        },
    },
];
export const DEMO_STATISTICS = {
    totalUsers: 39247,
    activeConnections: 127834,
    dataPointsShared: 2847563,
    averageDataValue: 5632,
    totalMetaFiles: 28456,
    storageUsed: 342,
    storageMax: 500,
    topCategories: [
        { name: 'Location', percentage: 82, color: '#22C55E', count: 8234 },
        { name: 'Communication', percentage: 89, color: '#3B82F6', count: 7123 },
        { name: 'Health', percentage: 86, color: '#EAB308', count: 6847 },
        { name: 'Finance', percentage: 81, color: '#14B8A6', count: 5643 },
        { name: 'Identity', percentage: 90, color: '#F97316', count: 4521 },
        { name: 'Social', percentage: 78, color: '#84CC16', count: 3892 },
        { name: 'Career', percentage: 75, color: '#06B6D4', count: 2987 },
    ],
    weeklyGrowth: 18.7,
    matchRate: 89,
};
export const CATEGORY_COLORS = {
    identity: '#F97316',
    health: '#EAB308',
    social: '#84CC16',
    location: '#22C55E',
    finance: '#14B8A6',
    career: '#06B6D4',
    communication: '#3B82F6',
    files: '#8B5CF6',
    everything: '#EC4899',
};
export const CATEGORY_ICONS = {
    identity: '🆔',
    health: '❤️',
    social: '👥',
    location: '📍',
    finance: '💰',
    career: '💼',
    communication: '💬',
    files: '📁',
    everything: '🌐',
};
